import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  cssVariables: true,
  palette: {
    primary: {
      main: "#500000",
      light: "#732f2f",
      dark: "#3c001c",
    },
  },
  typography: {
    fontFamily: "'Work Sans', sans-serif",
    h1: {
      fontFamily: "'Work Sans', sans-serif",
      fontSize: "28px",
      fontWeight: 700,
      color: "#500000",
    },
    h2: {
      fontFamily: "'Work Sans', sans-serif",
      fontSize: "26px",
      fontWeight: 700,
      color: "#500000",
    },
    h3: {
      fontFamily: "'Work Sans', sans-serif",
      fontSize: "24px",
      fontWeight: 700,
      color: "#500000",
    },
    h4: {
      fontFamily: "'Work Sans', sans-serif",
      fontSize: "20px",
      fontWeight: 700,
      color: "#500000",
    },
    h5: {
      fontFamily: "'Work Sans', sans-serif",
      fontSize: "18px",
      fontWeight: 700,
      color: "#500000",
    },
    h6: {
      fontFamily: "'Work Sans', sans-serif",
      fontSize: "16px",
      fontWeight: 700,
      color: "#500000",
    },
    body1: {
      fontFamily: "'Open Sans', sans-serif",
      fontSize: "16px",
      fontWeight: 400,
      color: "#000000",
    },
    body2: {
      fontFamily: "'Open Sans', sans-serif",
      fontSize: "14px",
      fontWeight: 400,
      color: "#000000",
    },
    subtitle1: {
      fontFamily: "'Work Sans', sans-serif",
      fontSize: "16px",
      fontWeight: 400,
      color: "#000000",
    },
    subtitle2: {
      fontFamily: "'Work Sans', sans-serif",
      fontSize: "14px",
      fontWeight: 700,
      color: "#000000",
    },
    caption: {
      fontFamily: "'Open Sans', sans-serif",
      fontSize: "12px",
      fontWeight: 400,
      color: "#666666",
    },
    overline: {
      fontFamily: "'Oswald', sans-serif",
      fontSize: "16px",
      fontWeight: 700,
      color: "#666666",
      textTransform: "uppercase",
    },
    // Custom variant for Overline 2
    overline2: {
      fontFamily: "'Oswald', sans-serif",
      fontSize: "14px",
      fontWeight: 700,
      color: "#666666",
      textTransform: "uppercase",
    },
    // Custom variant for Body 3
    body3: {
      fontFamily: "'Open Sans', sans-serif",
      fontSize: "20px",
      fontWeight: 400,
      color: "#000000",
    },
  },
  components: {
    MuiTablePagination: {
      defaultProps: {
        SelectProps: {
          MenuProps: {
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            MenuListProps: {
              sx: { padding: 0 },
            },
            PaperProps: {
              sx: {
                borderRadius: "0px",
                boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.12)",
                marginTop: "4px",
                border: "1px solid #eaeaea",
                "& .MuiMenuItem-root": {
                  fontSize: "0.875rem",
                  padding: "6px 16px",
                  margin: "0px",
                  borderRadius: "0px",
                },
              },
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
        outlined: {
          "&:hover": {
            color: "#FFF",
            //backgroundColor: "#550000"
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "#550000",
            color: "#FFFFFF",
            fontWeight: 700,
          },
          ":hover": {
            backgroundColor: "#aaa",
          },
        },
      },
    },
    /*
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 30,
        },
      },
    },*/
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: ".8em",
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: "red",
        },
        root: {
          fontSize: "1.25rem",
        },
      },
    },
    MuiFormControl: {
      defaultProps: {
        margin: "dense",
        size: "small",
      },
      styleOverrides: {
        root: {
          "&:has(.MuiInputLabel-root)": {
            marginTop: "1.5rem",
          },
          "& .MuiInputLabel-root": {
            position: "absolute",
            top: "-1.5rem",
            left: "0",
            fontSize: "1rem",
            fontWeight: 400,
            color: "#000000",
            backgroundColor: "white",
            padding: "0 0.25rem",
            margin: 0,
            transform: "none",
            zIndex: 1,
          },
          "& .MuiInputLabel-shrink": {
            position: "absolute",
            top: "-1.5rem",
            left: "0",
            fontSize: "1rem",
            fontWeight: 400,
            color: "#000000",
            backgroundColor: "white",
            padding: "0 0.25rem",
            margin: 0,
            transform: "none",
            zIndex: 1,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          transform: "translate(0, -.4rem) scale(1)",
          fontSize: "1rem",
          paddingLeft: "0.2rem",
          paddingRight: "0.5rem",
          marginLeft: 0,
          color: "#000000",
        },
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        notched: false,
      },
      styleOverrides: {
        root: {
          "&:has(.MuiInputLabel-root)": {
            marginTop: "1.5rem",
          },
          "& .MuiInputLabel-root": {
            position: "absolute",
            top: "-1.5rem",
            left: "0",
            fontSize: "1rem",
            fontWeight: 400,
            color: "#000000",
            backgroundColor: "white",
            padding: "0 0.25rem",
            margin: 0,
            transform: "none",
            zIndex: 1,
          },
          "& .MuiInputLabel-shrink": {
            position: "absolute",
            top: "-1.5rem",
            left: "0",
            fontSize: "1rem",
            fontWeight: 400,
            color: "#000000",
            backgroundColor: "white",
            padding: "0 0.25rem",
            margin: 0,
            transform: "none",
            zIndex: 1,
          },
          "& input:-webkit-autofill": {
            // Use box-shadow to simulate background-color, as background-color is often ignored
            WebkitBoxShadow: "0 0 0 100px #FFF inset",
            WebkitTextFillColor: "#550000", // Change text color for autofill
            transition:
              "background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s", // Prevent instant transition
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        slotProps: {
          input: { notched: false },
        },
        size: "small",
      },
      styleOverrides: {
        root: {
          "&:has(.MuiInputLabel-root)": {
            marginTop: "1.5rem",
          },
          "& .MuiInputLabel-root": {
            position: "absolute",
            top: "-1.5rem",
            left: "0",
            fontSize: "1rem",
            fontWeight: 400,
            color: "#000000",
            backgroundColor: "white",
            padding: "0 0.25rem",
            margin: 0,
            transform: "none",
            zIndex: 1,
          },
          "& .MuiInputLabel-shrink": {
            position: "absolute",
            top: "-1.5rem",
            left: "0",
            fontSize: "1rem",
            fontWeight: 400,
            color: "#000000",
            backgroundColor: "white",
            padding: "0 0.25rem",
            margin: 0,
            transform: "none",
            zIndex: 1,
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#500000",
          "&.Mui-checked": {
            color: "#500000",
          },
          "&.MuiCheckbox-indeterminate": {
            color: "#500000",
          },
          "&:hover": {
            backgroundColor: "rgba(80, 0, 0, 0.04)",
          },
        },
      },
    },
    MuiTooltip: {
      defaultProps: {
        arrow: true,
        placement: "top",
      },
      styleOverrides: {
        tooltip: {
          backgroundColor: "var(--tamu-maroon)",
          boxShadow: "0px 3px 6px rgba(0,0,0,0.2)",
          maxWidth: 250,
          color: "#fff",
          fontSize: "13px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {},
      },
    },
    MuiSelect: {
      defaultProps: {
        notched: false,
        size: "small",
      },
      styleOverrides: {
        root: {
          "&:has(.MuiInputLabel-root)": {
            marginTop: "1.5rem",
          },
          "& .MuiInputLabel-root": {
            position: "absolute",
            top: "-1.5rem",
            left: "0",
            fontSize: "1rem",
            fontWeight: 400,
            color: "#000000",
            backgroundColor: "white",
            padding: "0 0.25rem",
            margin: 0,
            transform: "none",
            zIndex: 1,
          },
          "& .MuiInputLabel-shrink": {
            position: "absolute",
            top: "-1.5rem",
            left: "0",
            fontSize: "1rem",
            fontWeight: 400,
            color: "#000000",
            backgroundColor: "white",
            padding: "0 0.25rem",
            margin: 0,
            transform: "none",
            zIndex: 1,
          },
          "& input:-webkit-autofill": {
            // Use box-shadow to simulate background-color, as background-color is often ignored
            WebkitBoxShadow: "0 0 0 100px #FFF inset",
            WebkitTextFillColor: "#550000", // Change text color for autofill
            transition:
              "background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s", // Prevent instant transition
          },
        },
      },
    },
    // MUI X DatePicker configuration
    MuiDatePicker: {
      defaultProps: {
        slotProps: {
          textField: {
            size: "small",
            margin: "dense",
          },
        },
      },
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            border: "1px solid rgba(0, 0, 0, 0.23) !important",
            clipPath: "none !important",
            "&:hover": {
              border: "2px solid rgba(0, 0, 0, 0.23) !important",
            },
            "&.Mui-focused": {
              border: "2px solid #500000 !important",
            },
          },
          "& .MuiInputLabel-root": {
            "&.MuiInputLabel-shrink": {
              transform: "translate(14px, -9px) scale(0.75) !important",
              backgroundColor: "white !important",
              padding: "0 4px !important",
            },
          },
        },
      },
    },
  },
});

export default theme;
